<ng-container *transloco="let t; read: 'siteManagementScope.SITE_MANAGEMENT.SITE_DETAIL.SITE_BOARDS_EDITOR'">
  <avn-select [label]="t('SELECT_BOARD_50')" [options]="boards$ | async" [value]="selectedBoard$ | async" (change)="onBoardChange($event?.value)"></avn-select>
</ng-container>
